import type { CPNavigationInput } from '@common/navigation-layer/types/navigation'

const DUMMY_ORIGIN = 'https://clientportal.invalid'

/**
 * Turns the `/auth?...` URL produced by `getMagicLinkAuthUrl` / `appendShowBetaPreviewToUrl`
 * into a {@link CPNavigationInput} so magic-link forwarding uses the same navigation path as the rest of the app.
 */
export function buildMagicLinkAuthCpNavigationInput(
  authUrl: string,
  navigateOptions: NonNullable<CPNavigationInput['options']>,
  currentRouteContext?: CPNavigationInput['currentRouteContext']
): CPNavigationInput {
  const url = new URL(authUrl, DUMMY_ORIGIN)
  if (url.pathname !== '/auth') {
    throw new Error(`buildMagicLinkAuthCpNavigationInput: expected pathname /auth, received ${url.pathname}`)
  }

  const query: Record<string, string | number | boolean | string[]> = {}
  url.searchParams.forEach((value, key) => {
    query[key] = value
  })

  return {
    name: 'auth',
    query,
    options: navigateOptions,
    ...(currentRouteContext ? { currentRouteContext } : {}),
  }
}
